import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Switch, Route, useLocation } from "react-router-dom";
import "./../styles/Contact.scss";
import Api from "../common/api";

const Content = () => {
    const [data, setData] = useState([]);
    const lang = localStorage.getItem("lang");

    let size = 2;
    if(lang == "en"){
        size = 3;
    }
    const [activePath, setActivePath] = useState(
        useLocation().pathname.split("/")[size]
    );

    const [Paths, setPaths] = useState(useLocation().pathname.split("/"));

    React.useEffect(() => {
        Api.get("/home/getdetail?slug=" + Paths[size]).then((res) => {
            setData(res.data.content);
        });
    }, [activePath]);

    return (
        <>
            <header
                className="contact-header"
                style={{
                    backgroundImage:
                        `url("https://sankoenerji.com.tr/Uploads/MediaCenter/contactbg.4e91eb01.jpg")`,
                }}
            ></header>
            <div className="corporate-container">
                <div className="corporate-content container-sm">
                    {data ?
                        (
                            lang == "en" ? (
                                data.Title_EN ? (
                            <>
                                <br />
                                <h3>{data.Title_EN}</h3>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: data.Content__EN,
                                    }}
                                ></div>
                            </>
                            ):""
                            ):(
                                    data.Title ? (
                                        <>
                                            <br />
                                            <h3>{data.Title}</h3>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: data.Content_TR,
                                                }}
                                            ></div>
                                        </>
                                    ):""
                                )
                            )
                        : ''}
                </div>
            </div>
        </>
    );
};

export default Content;
